/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CreateApiKeyRequestFromJSON(json) {
    return CreateApiKeyRequestFromJSONTyped(json, false);
}
export function CreateApiKeyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        serviceUserId: json['serviceUserId'],
    };
}
export function CreateApiKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        serviceUserId: value.serviceUserId,
    };
}
